import React from 'react';

import { navigate, url } from 'js/services/Network';

import Container from './Container';
import Buyer from './Buyer';
import Location from './Location';
import Price from './Price';
import Shipping from './Shipping';
import Buttons from './Buttons';
import Icon from './Icon';

export default ({ order }) => (
  <Container onClick={() => navigate(url('status-page', order))}>
    <Buyer>{order.buyer}</Buyer>
    <Location>{`${order.delivery.city}, ${order.delivery.state} ${order.delivery.zip}`}</Location>
    <Price>{order.item_price}</Price>
    <Shipping>{order.shipping}</Shipping>
    <Buttons>
      <Icon name="chevron-right" />
    </Buttons>
  </Container>
);
